(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5376],{

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 99201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor/[vendorUrlKey]",
      function () {
        return __webpack_require__(58169);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56055);



var AccordionItemBody = function(param) {
    var children = param.children, isExpanded = param.isExpanded, isPreRendered = param.isPreRendered;
    var onContentSizeChange = function onContentSizeChange(size) {
        if (size && contentHeight !== size) {
            setContentHeight("".concat(size.height, "px"));
        }
    };
    // Using height 100% doesn't break functionality
    // despite animations not working
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isContainerRendered = ref[0], setIsContainerRendered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("100%"), contentHeight = ref1[0], setContentHeight = ref1[1];
    var setContainerRef = (0,_lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(onContentSizeChange);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isExpanded || isPreRendered) {
            setIsContainerRendered(true);
        }
    }, [
        isExpanded,
        isPreRendered
    ]);
    var containerHeight = isExpanded ? contentHeight : 0;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "overflow-hidden transition-[height] ease-in-out duration-[300ms]",
        style: {
            height: containerHeight
        },
        children: isContainerRendered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: setContainerRef,
            className: "pb-8",
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItemBody);


/***/ }),

/***/ 85929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Accordion/Item/HeaderToggleButton.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var HeaderToggleButton = function(param) {
    var onToggle = param.onToggle, isExpanded = param.isExpanded;
    // TODO: website-next - Replace with Button component
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
        className: isBricoStore ? "rounded-full bg-gray-lighter px-3 py-2" : "rounded bg-filterYellow px-3 py-2",
        onClick: onToggle,
        children: isExpanded ? "Ascunde" : "Detalii"
    });
};
/* harmony default export */ var Item_HeaderToggleButton = (HeaderToggleButton);

;// CONCATENATED MODULE: ./components/Accordion/Item/Header.js



var AccordionItemHeader = function(param) {
    var isExpanded = param.isExpanded, isToggleable = param.isToggleable, _hasToggleButton = param.hasToggleButton, hasToggleButton = _hasToggleButton === void 0 ? false : _hasToggleButton, renderToggleButton = param.renderToggleButton, onToggle = param.onToggle, children = param.children;
    if (!hasToggleButton) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between py-7 ".concat(isToggleable ? "cursor-pointer" : ""),
            onClick: onToggle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                isToggleable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "transition-transform ease-linear ".concat(isExpanded ? "rotate-180" : "rotate-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "16px",
                        height: "16px"
                    })
                })
            ]
        }));
    }
    var toggleButton = renderToggleButton && renderToggleButton({
        toggleItem: onToggle,
        isItemExpanded: isExpanded
    }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_HeaderToggleButton, {
        isExpanded: isExpanded,
        onToggle: onToggle
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between py-4 ",
        children: [
            children,
            isToggleable && toggleButton
        ]
    }));
};
/* harmony default export */ var Header = (AccordionItemHeader);


/***/ }),

/***/ 4259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var AccordionItem = function(param) {
    var id = param.id, children = param.children, _isPreRendered = param.isPreRendered, isPreRendered = _isPreRendered === void 0 ? true : _isPreRendered;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), onItemToggle = ref.onItemToggle, isItemToggleable = ref.isItemToggleable, isItemExpanded = ref.isItemExpanded;
    var handleToggle = function(event) {
        return onItemToggle(id, event);
    };
    var isExpanded = isItemExpanded(id);
    var isToggleable = isItemToggleable(id);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
            /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
                id: id,
                isPreRendered: isPreRendered,
                isExpanded: isExpanded,
                isToggleable: isToggleable,
                onToggle: handleToggle
            }) : child;
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 84849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (AccordionContext);


/***/ }),

/***/ 71604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Accordion/useAccordion.js

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useAccordion = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "closable" : _mode, _expandedItems = param.expandedItems, expandedItems = _expandedItems === void 0 ? [] : _expandedItems, _onToggle = param.onToggle, onToggle = _onToggle === void 0 ? function() {} : _onToggle;
    if (![
        "closable",
        "always-one",
        "max-one"
    ].includes(mode)) {
        throw new Error("Unrecognized \"".concat(mode, "\" for Accordion"));
    }
    if (mode === "always-one" && expandedItems.length !== 1) {
        throw new Error("always-one mode requires only one initial item");
    }
    if (mode === "max-one" && expandedItems.length > 1) {
        throw new Error("max-one mode allows none or only one initial item");
    }
    var ref = (0,react.useState)(expandedItems), expanded = ref[0], setExpanded = ref[1];
    var isItemExpanded = function(item) {
        return expanded === null || expanded === void 0 ? void 0 : expanded.includes(item);
    };
    var isItemToggleable = function(item) {
        return mode === "always-one" ? !isItemExpanded(item) : true;
    };
    (0,react.useEffect)(function() {
        setExpanded(expandedItems);
    }, [
        expandedItems
    ]);
    var onItemToggle = function(item, event) {
        switch(mode){
            case "always-one":
                {
                    if (!isItemExpanded(item)) {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "max-one":
                {
                    if (isItemExpanded(item)) {
                        setExpanded([]);
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "closable":
            default:
                {
                    if (isItemExpanded(item)) {
                        setExpanded(expanded.filter(function(expandedItem) {
                            return item !== expandedItem;
                        }));
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded(_toConsumableArray(expanded).concat([
                            item
                        ]));
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                }
        }
    };
    return {
        isItemToggleable: isItemToggleable,
        isItemExpanded: isItemExpanded,
        onItemToggle: onItemToggle
    };
};
/* harmony default export */ var Accordion_useAccordion = (useAccordion);

// EXTERNAL MODULE: ./components/Accordion/accordionContext.js
var accordionContext = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Accordion/index.js



var Accordion = function(param) {
    var mode = param.mode, expandedItems = param.expandedItems, onToggle = param.onToggle, children = param.children;
    var ref = Accordion_useAccordion({
        mode: mode,
        expandedItems: expandedItems,
        onToggle: onToggle
    }), isItemExpanded = ref.isItemExpanded, isItemToggleable = ref.isItemToggleable, onItemToggle = ref.onItemToggle;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(accordionContext/* default.Provider */.Z.Provider, {
        value: {
            isItemExpanded: isItemExpanded,
            isItemToggleable: isItemToggleable,
            onItemToggle: onItemToggle
        },
        children: children
    }));
};
/* harmony default export */ var components_Accordion = (Accordion);


/***/ }),

/***/ 96936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);



var HtmlEmbed = function(props) {
    var createMarkup = function(content) {
        return {
            __html: content
        };
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: props.className,
        children: [
            props.html && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: createMarkup(props.html)
            }),
            props.script && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: _lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setDangerousHtml.bind */ .RR.bind(null, props.script)
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HtmlEmbed);


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);




var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// bricostore-only pagination overrides (circular/pill shape + red active border); altex/MG untouched
// replace (not append) the radius so there's a single rounded-* class → no cascade conflict
var pageRadius = isBricoStore ? "rounded-full" : "rounded-md";
var activePageClass = isBricoStore ? "bg-red-brand text-white border-red-brand" : "bg-alertRed text-white";
var Pagination = function(param) {
    var pages = param.pages, goTo = param.goTo, activePage = param.activePage, _meta = param.meta, meta = _meta === void 0 ? {} : _meta, _showMeta = param.showMeta, showMeta = _showMeta === void 0 ? false : _showMeta, _alignment = param.alignment, alignment = _alignment === void 0 ? "justify-end" : _alignment;
    if (!pages || !goTo || !activePage || pages < 2) {
        return null;
    }
    var pagesArr = [];
    for(var index = 1; index <= pages; index++){
        pagesArr.push(index);
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Toolbar flow-root",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-wrap items-center py-3 lg:pb-15px ".concat(alignment),
            children: [
                showMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-sm w-full text-center mb-20px sm:mb-0 sm:text-left sm:w-auto sm:block md:pr-2",
                    children: [
                        meta.limit * meta.page + 1,
                        " -",
                        (meta.page + 1) * meta.limit < meta.size ? meta.limit * (meta.page + 1) : meta.size,
                        " ",
                        "din ",
                        meta.size,
                        " de recenzii"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "".concat(activePage == 1 ? "text-gray cursor-not-allowed pointer-events-none" : "", " inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ").concat(pageRadius, " items-center text-center bg-white"),
                    title: "Inapoi",
                    onClick: function(e) {
                        activePage > 1 ? goTo(activePage - 1) : e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden md:inline-block",
                            children: "Pagina anterioara"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "Toolbar-previous md:hidden"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "flex list-none m-0 p-0",
                        children: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getPaginationInterval */ .CR)(pagesArr, activePage - 1).map(function(page, i) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: (page <= 20 || page === "...") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    defaultValue: activePage,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "\n                    mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ".concat(pageRadius, "\n                    ").concat(page == activePage ? activePageClass : "bg-white", "\n                    ").concat(page == activePage || page == "..." ? "cursor-not-allowed pointer-events-none" : "", "\n                  "),
                                        onClick: function() {
                                            goTo(page);
                                        },
                                        children: page
                                    })
                                }, "".concat(page, "-").concat(i))
                            }, "fragment-".concat(page, "-").concat(i));
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "".concat(activePage == pages ? "text-gray cursor-not-allowed pointer-events-none" : "", " inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ").concat(pageRadius, " items-center text-center bg-white"),
                    title: "Inainte",
                    onClick: function(e) {
                        activePage != pages ? goTo(activePage + 1) : e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden md:inline-block",
                            children: "Pagina urmatoare"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "Toolbar-next md:hidden"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 56055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useElementSize = function(setElementSize) {
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), height = ref3[0], setHeight = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), width = ref1[0], setWidth = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var setElementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(element) {
        return ref2.current = element;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref2.current) {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    var ref;
                    if ((ref = entry.borderBoxSize) === null || ref === void 0 ? void 0 : ref[0]) {
                        var newHeight = entry.borderBoxSize[0].blockSize;
                        var newWidth = entry.borderBoxSize[0].inlineSize;
                        if (height !== newHeight || width !== newWidth) {
                            setElementSize({
                                height: newHeight,
                                width: newWidth
                            });
                            setHeight(newHeight);
                            setWidth(newWidth);
                        }
                    }
                });
            };
            try {
                var observer = new ResizeObserver(callback);
                observer.observe(ref2.current);
                return function() {
                    return observer.disconnect();
                };
            } catch (error) {
            // No Resize Observer
            }
        }
    }, [
        ref2,
        setElementSize
    ]);
    return setElementRef;
};
/* harmony default export */ __webpack_exports__["Z"] = (useElementSize);


/***/ }),

/***/ 58169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _vendorUrlKey_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./store/sellers/actions.js
var actions = __webpack_require__(33510);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Seller/SellerInfo.js


var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var SellerInfo = function(param) {
    var _seller = param.seller, name = _seller.name, company_cui = _seller.company_cui, company_name = _seller.company_name, address = _seller.address, phone = _seller.phone, email = _seller.email, company_fiscal_number = _seller.company_fiscal_number;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: isBricoStore ? "bd-display3" : "text-2xl font-medium leading-31.2 md:text-[34px]",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "leading-6 my-6",
                children: [
                    company_name && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "Denumire:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: company_name
                            })
                        ]
                    }),
                    address && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "Adresa:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: address
                            })
                        ]
                    }),
                    company_cui && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "CUI:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: company_cui
                            })
                        ]
                    }),
                    company_fiscal_number && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "Nr.Inreg.Reg.Com.:"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: company_fiscal_number
                            })
                        ]
                    }),
                    phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "Telefon:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: phone
                            })
                        ]
                    }),
                    email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "min-w-[30%] md:min-w-[15%] font-medium",
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: email
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Seller_SellerInfo = (SellerInfo);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ContentEditorView/HtmlEmbed.js
var HtmlEmbed = __webpack_require__(96936);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./components/Icons/RatingStar.js
var RatingStar = __webpack_require__(21276);
;// CONCATENATED MODULE: ./components/Seller/SellerReviews/SellerReviewsStarRating.js



var SellerReviewsStarRating = function(param) {
    var _reviewsCount = param.reviewsCount, reviewsCount = _reviewsCount === void 0 ? 1 : _reviewsCount, _reviewsRating = param.reviewsRating, reviewsRating = _reviewsRating === void 0 ? 0 : _reviewsRating;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative inline-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: times_default()(5, function(i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                        width: "20px",
                        height: "20px",
                        className: "mr-1 text-gray-light"
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inline-block top-0 left-0 right-0 overflow-hidden",
                style: {
                    width: "".concat(reviewsRating / reviewsCount <= 5 ? parseFloat((reviewsRating / reviewsCount * 100 / 5).toFixed(2)) : 0, "%")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: times_default()(5, function(i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                width: "20px",
                                height: "20px",
                                className: "mr-1 fill-current flex-none text-yellow"
                            }, i);
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var SellerReviews_SellerReviewsStarRating = (SellerReviewsStarRating);

;// CONCATENATED MODULE: ./components/Seller/SellerReviews/SellerReviewsInfo.js




var SellerReviewsInfo = function(param) {
    var reviewsSummary = param.reviewsSummary, userCanPostReview = param.userCanPostReview;
    var reviewsCount = get_default()(reviewsSummary, "items[0].reviews.value", 0);
    var reviewsRating = get_default()(reviewsSummary, "items[0].reviews.total", 0);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:flex items-start mt-4 mb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "min-w-[200px] text-center",
            children: [
                reviewsSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "my-0 text-4xl lg:text-40px text-black font-medium",
                            children: [
                                isNaN(reviewsRating / reviewsCount) ? 0 : Math.round((reviewsRating / reviewsCount + Number.EPSILON) * 100) / 100,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-light",
                                    children: " din 5"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4 md:mb-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewsStarRating, {
                                reviewsCount: reviewsCount,
                                reviewsRating: reviewsRating
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Adauga recenzia ta",
                        display: "block",
                        size: "normal",
                        onClick: function() {
                            return userCanPostReview();
                        }
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var SellerReviews_SellerReviewsInfo = (SellerReviewsInfo);

;// CONCATENATED MODULE: ./components/Seller/SellerReviews/SellerReviewsChart.js



var SellerReviewsChart = function(param) {
    var reviewsSummary = param.reviewsSummary;
    var reviewsCount = get_default()(reviewsSummary, "items[0].reviews.value", 0);
    var reviewSummaryElements = [];
    for(var index = 5; index > 0; index--){
        var styles = {
            width: "",
            backgroundColor: ""
        };
        var distribution = 0;
        switch(index){
            case 5:
                styles.width = "".concat(parseFloat(get_default()(reviewsSummary, "items[0].ratingDistribution[5]", 0) * 100 / reviewsCount).toFixed(2), "%");
                styles.backgroundColor = "#DCE02B";
                distribution = get_default()(reviewsSummary, "items[0].ratingDistribution[5]", 0);
                break;
            case 4:
                styles.width = "".concat(parseFloat(get_default()(reviewsSummary, "items[0].ratingDistribution[4]", 0) * 100 / reviewsCount).toFixed(2), "%");
                styles.backgroundColor = "#A3D720";
                distribution = get_default()(reviewsSummary, "items[0].ratingDistribution[4]", 0);
                break;
            case 3:
                styles.width = "".concat(parseFloat(get_default()(reviewsSummary, "items[0].ratingDistribution[3]", 0) * 100 / reviewsCount).toFixed(2), "%");
                styles.backgroundColor = "#DCE02B";
                distribution = get_default()(reviewsSummary, "items[0].ratingDistribution[3]", 0);
                break;
            case 2:
                styles.width = "".concat(parseFloat(get_default()(reviewsSummary, "items[0].ratingDistribution[2]", 0) * 100 / reviewsCount).toFixed(2), "%");
                styles.backgroundColor = "#FD861A";
                distribution = get_default()(reviewsSummary, "items[0].ratingDistribution[2]", 0);
                break;
            case 1:
                styles.width = "".concat(parseFloat(get_default()(reviewsSummary, "items[0].ratingDistribution[1]", 0) * 100 / reviewsCount).toFixed(2), "%");
                styles.backgroundColor = "#D71541";
                distribution = get_default()(reviewsSummary, "items[0].ratingDistribution[1]", 0);
                break;
            default:
                styles.width = "";
                styles.backgroundColor = "";
        }
        reviewSummaryElements.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center mb-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-2 text-sm font-bold leading-15.6",
                    children: index
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                        className: "w-13px h-13px ml-3px text-yellow"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-3 mx-3 relative overflow-hidden rounded-full grow bg-newGray",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute rounded-full top-0 left-0 bottom-0",
                        style: styles
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-6 text-sm text-red-brand leading-15.6",
                    children: distribution
                })
            ]
        }, index.toString() + "1"));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:ml-52px w-full md:max-w-[525px]",
        children: reviewSummaryElements
    }));
};
/* harmony default export */ var SellerReviews_SellerReviewsChart = (SellerReviewsChart);

;// CONCATENATED MODULE: ./components/Seller/SellerReviews/SellerReviewsHeader.js





var SellerReviewsHeader = function(param) {
    var reviewsSummary = param.reviewsSummary;
    var router = (0,next_router.useRouter)();
    var userCanPostReview = function() {
        router.push("/cont/comenzi/");
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row md:items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewsInfo, {
                reviewsSummary: reviewsSummary,
                userCanPostReview: userCanPostReview
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewsChart, {
                reviewsSummary: reviewsSummary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Adauga recenzia ta",
                    display: "block",
                    size: "normal",
                    onClick: function() {
                        return userCanPostReview();
                    }
                })
            })
        ]
    }));
};
/* harmony default export */ var SellerReviews_SellerReviewsHeader = (SellerReviewsHeader);

// EXTERNAL MODULE: ./components/Pagination.js
var Pagination = __webpack_require__(5625);
;// CONCATENATED MODULE: ./components/Seller/SellerReviews/SellerReviewList.js



var dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric"
};
var SellerReviewList = function(param) {
    var reviews = param.reviews, setPage = param.setPage;
    var goToPage = function(page) {
        setPage(page - 1);
        window.scrollTo({
            top: 400,
            left: 0,
            behavior: "smooth"
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: !!reviews && reviews.items && reviews.items.length > 0 && reviews.items.map(function(review, index) {
                    var reviewDate = new Date(review.updatedAt ? review.updatedAt : review.createdAt).toLocaleDateString("ro-RO", dateOptions);
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "md:flex mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "py-2 md:py-0 md:flex flex-col md:min-w-[20%] leading-22 -tracking-0.16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-semibold",
                                        children: review.customer.alias || review.customer.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mx-2 text-gray-1200 md:hidden",
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gray-1200",
                                        children: reviewDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full pb-6 border-b border-gray-1100 ".concat(reviews.meta.total_pages === 1 && reviews.meta.size - 1 === index ? "border-none" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewsStarRating, {
                                        reviewsRating: review.rating
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "break-all text-sm leading-22 ",
                                        children: review.body
                                    })
                                ]
                            })
                        ]
                    }, review._id));
                })
            }),
            !!reviews && reviews.meta && reviews.meta.size > reviews.meta.limit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:flex justify-end my-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full md:w-5/6 pl-0 md:pl-8 mt-10px mb-12 md:mb-0 md:mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        pages: reviews.meta.total_pages,
                        goTo: function(pg) {
                            return goToPage(pg);
                        },
                        activePage: reviews.meta.page + 1,
                        meta: reviews.meta,
                        showMeta: true,
                        alignment: "justify-center"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var SellerReviews_SellerReviewList = (SellerReviewList);

// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./components/Seller/SellerReviews/index.js









function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SellerReviews = function(param) {
    var seller_id = param.seller_id, reviewsSummary = param.reviewsSummary, apiCall1 = param.apiCall;
    var ref = (0,react.useState)(), reviews = ref[0], setReviews = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(0), page = ref2[0], setPage = ref2[1];
    var getSellerReviews = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var payload, req;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsLoading(true);
                    payload = {
                        seller_id: seller_id,
                        page: page
                    };
                    _ctx.next = 4;
                    return apiCall1({
                        apiCall: api/* getSellerReviewsApi */.u_m,
                        apiArgs: [
                            payload
                        ],
                        formatResponse: function(response) {
                            return response.data;
                        },
                        returnResponse: true
                    });
                case 4:
                    req = _ctx.sent;
                    setReviews(req);
                    setIsLoading(false);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        seller_id,
        page
    ]);
    (0,react.useEffect)(function() {
        getSellerReviews();
    }, [
        page,
        getSellerReviews
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewsHeader, {
                reviewsSummary: reviewsSummary
            }),
            isLoading && !reviews ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                height: 80
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerReviews_SellerReviewList, {
                reviews: reviews,
                setPage: setPage
            })
        ]
    }));
};
/* harmony default export */ var Seller_SellerReviews = ((0,es/* connect */.$j)(null, {
    apiCall: app_actions/* apiCall */.k_
})(SellerReviews));

// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(71604);
// EXTERNAL MODULE: ./components/Accordion/Item/index.js
var Item = __webpack_require__(4259);
// EXTERNAL MODULE: ./components/Accordion/Item/Header.js + 1 modules
var Header = __webpack_require__(85929);
// EXTERNAL MODULE: ./components/Accordion/Item/Body.js
var Body = __webpack_require__(66707);
// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/Seller/SellerTabs.js












var SellerTabs = function(param1) {
    var reviewsSummary = param1.reviewsSummary, _seller = param1.seller, id = _seller.id, description = _seller.description, shipping_info = _seller.shipping_info, rma_info = _seller.rma_info, warranty_info = _seller.warranty_info, customer_confidentiality_info = _seller.customer_confidentiality_info;
    var ref, ref1, ref2, ref3;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref4 = (0,react.useState)(""), openedSection = ref4[0], setOpenedSection = ref4[1];
    (0,react.useEffect)(function() {
        var hash = asPath.split("#")[1];
        if (hash) {
            var hashSlug = (0,helpers/* getSlug */.QF)(hash);
            var sectionElement = document.getElementById(hashSlug);
            if (sectionElement) {
                setOpenedSection(hashSlug);
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (openedSection) {
            var sectionElement = document.getElementById(openedSection);
            sectionElement.scrollIntoView();
        }
    }, [
        openedSection
    ]);
    var ref5;
    var reviewsCount = (ref5 = (ref = reviewsSummary === null || reviewsSummary === void 0 ? void 0 : reviewsSummary.items[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.reviews) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref5 !== void 0 ? ref5 : 0;
    var ref6;
    var reviewsScore = (ref6 = (ref2 = reviewsSummary === null || reviewsSummary === void 0 ? void 0 : reviewsSummary.items[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reviews) === null || ref3 === void 0 ? void 0 : ref3.total) !== null && ref6 !== void 0 ? ref6 : 0;
    var reviewAverage = Math.round((reviewsScore / reviewsCount + Number.EPSILON) * 100) / 100;
    var onAccordionItemToggle = function(param) {
        var item = param.item, expanded = param.expanded;
        return history.replaceState({}, "", "#".concat(expanded ? item : ""));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "divide-y divide-gray-900 border-y",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            expandedItems: openedSection ? [
                openedSection
            ] : [],
            onToggle: onAccordionItemToggle,
            children: [
                reviewsSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "reviews",
                    isPreRendered: false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center space-x-2.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        as: "h2",
                                        display: "h2",
                                        title: "Recenzii"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                                        reviewsCount: reviewsCount,
                                        ratingSummary: reviewsScore,
                                        displayRatingScore: true,
                                        displayIfEmpty: false,
                                        productUrl: ""
                                    }),
                                    Boolean(reviewsScore) && Boolean(reviewsCount) && reviewsCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "align-middle inline-block text-2xl font-medium mx-10px lg:mr-7px",
                                        children: reviewAverage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inline-block py-1 px-2 min-w-[30px] bg-yellow rounded-md text-sm leading-none align-middle text-center",
                                        children: reviewsCount > 0 ? reviewsCount : "0"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Seller_SellerReviews, {
                                reviewsSummary: reviewsSummary,
                                seller_id: id
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "descriere",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Descriere"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                html: description || "Nu exista informatii"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "politica-de-livrare",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Politica de livrare"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                html: shipping_info || "Nu exista informatii"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "politica-de-returnare",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Politica de returnare"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                html: rma_info || "Nu exista informatii"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "politica-de-garantie",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Politica de garantie"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                html: warranty_info || "Nu exista informatii"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                    id: "politica-de-confidentialitate",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Politica de confidentialitate"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                html: customer_confidentiality_info || "Nu exista informatii"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Seller_SellerTabs = (SellerTabs);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/Seller/SellerProducts.js


var SellerProducts = function(param) {
    var seller = param.seller, categories = param.categories;
    var productsCount = categories.reduce(function(count, category) {
        return count + category.product_count;
    }, 0);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "my-14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-6 md:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "text-xl md:text-2xl lg:text-[34px] leading-26",
                        children: [
                            "Produse vandute de ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium",
                                children: seller.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex text-gray-light mt-[2px] leading-7 text-lg md:ml-4 md:text-xl lg:text-[28px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block mr-2",
                                children: "•"
                            }),
                            productsCount
                        ]
                    })
                ]
            }),
            categories.map(function(category) {
                var ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-medium text-22px leading-28.6 mt-8",
                            children: category.name
                        }),
                        ((ref1 = category.subcategories) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:grid gap-4 md:grid-cols-2 lg:grid-cols-3",
                            children: category.subcategories.map(function(subcategory) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/".concat(subcategory.url_key, "/cpl/filtru/seller-ids/").concat(seller.id, "-").concat(seller.url_key),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "text-base leading-28.6 mt-4",
                                                children: [
                                                    subcategory.name,
                                                    " (",
                                                    subcategory.product_count,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        subcategory === null || subcategory === void 0 ? void 0 : (ref = subcategory.subcategories) === null || ref === void 0 ? void 0 : ref.map(function(subcategoryCategories) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/".concat(subcategoryCategories.url_key, "/cpl/filtru/seller-ids/").concat(seller.id, "-").concat(seller.url_key),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "text-sm text-[#0094EB] leading-6 ml-4 mt-1",
                                                    children: [
                                                        subcategoryCategories.name,
                                                        " (",
                                                        subcategoryCategories.product_count,
                                                        ")"
                                                    ]
                                                })
                                            }, subcategoryCategories.id);
                                        })
                                    ]
                                }, subcategory.id);
                            })
                        })
                    ]
                }, category.id);
            })
        ]
    }));
};
/* harmony default export */ var Seller_SellerProducts = (SellerProducts);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
;// CONCATENATED MODULE: ./pages/vendor/[vendorUrlKey].js









function _vendorUrlKey_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _vendorUrlKey_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _vendorUrlKey_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _vendorUrlKey_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SellerPage = function(param) {
    var seller = param.seller, categories = param.categories, reviewsSummary = param.reviewsSummary;
    if (!seller) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    className: "jsx-9a59f085cfe8297d",
                    children: seller.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-9a59f085cfe8297d" + " " + "mt-[36px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seller_SellerInfo, {
                        seller: seller
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seller_SellerTabs, {
                        seller: seller,
                        reviewsSummary: reviewsSummary
                    }),
                    (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seller_SellerProducts, {
                        seller: seller,
                        categories: categories
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "9a59f085cfe8297d",
                children: "html{scroll-behavior:smooth;\nscroll-padding-top:1rem;\noverflow-anchor:none}"
            })
        ]
    }));
};
SellerPage.pageLayout = "default";
SellerPage.getInitialProps = (function() {
    var _ref = _vendorUrlKey_asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var vendorUrlKey, reduxStore, seller, categories, reviewsSummary;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    vendorUrlKey = ctx.query.vendorUrlKey, reduxStore = ctx.reduxStore;
                    _ctx.next = 3;
                    return reduxStore.dispatch((0,actions/* getSellerByUrlKey */.I2)(vendorUrlKey));
                case 3:
                    seller = _ctx.sent;
                    if (seller) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 6:
                    _ctx.next = 8;
                    return reduxStore.dispatch((0,actions/* getSellerCategories */.Dp)(seller.id));
                case 8:
                    categories = _ctx.sent;
                    if ([
                        1,
                        2
                    ].includes(seller.id)) {
                        _ctx.next = 15;
                        break;
                    }
                    _ctx.next = 12;
                    return reduxStore.dispatch((0,actions/* getSellerReviewsSummary */.XH)(seller.id));
                case 12:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 16;
                    break;
                case 15:
                    _ctx.t0 = null;
                case 16:
                    reviewsSummary = _ctx.t0;
                    return _ctx.abrupt("return", {
                        vendorUrlKey: vendorUrlKey,
                        seller: seller,
                        categories: categories,
                        reviewsSummary: reviewsSummary
                    });
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var _vendorUrlKey_ = (SellerPage);


/***/ }),

/***/ 33510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w8": function() { return /* binding */ getSellers; },
/* harmony export */   "I2": function() { return /* binding */ getSellerByUrlKey; },
/* harmony export */   "Dp": function() { return /* binding */ getSellerCategories; },
/* harmony export */   "Yb": function() { return /* binding */ removeSeller; },
/* harmony export */   "XH": function() { return /* binding */ getSellerReviewsSummary; }
/* harmony export */ });
/* unused harmony export getSellerById */
/* harmony import */ var _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8503);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);



var getSellers = function(sellersIds) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER */ .t6,
                success: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_SUCCESS */ .jK,
                fail: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_FAILURE */ .Xd
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSellersApi */ .MdJ,
            apiArgs: [
                sellersIds
            ],
            formatResponse: function(response) {
                return response.data.sellers;
            },
            returnResponse: true
        });
    };
};
var getSellerById = function(seller_id) {
    return function(dispatch, getState) {
        return makeApiCall({
            actions: {
                action: GET_SELLER_BY_ID,
                success: GET_SELLER_BY_ID_SUCCESS,
                fail: GET_SELLER_BY_ID_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: getSellerByIdApi,
            apiArgs: [
                seller_id
            ],
            formatResponse: function(response) {
                return response.data.seller;
            },
            returnResponse: true
        });
    };
};
var getSellerByUrlKey = function(url_key) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_BY_URL_KEY */ .g1,
                success: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_BY_URL_KEY_SUCCESS */ .k,
                fail: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_BY_URL_KEY_FAILURE */ .ZC
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSellerByUrlKeyApi */ .eXS,
            apiArgs: [
                url_key
            ],
            formatResponse: function(response) {
                return response.data.sellers[0];
            },
            returnResponse: true
        });
    };
};
var getSellerCategories = function(seller_id) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_CATEGORIES */ .NF,
                success: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_CATEGORIES_SUCCESS */ .Wn,
                fail: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SELLER_CATEGORIES_FAILURE */ .GQ
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSellerCategoriesApi */ .IQu,
            apiArgs: [
                seller_id
            ],
            formatResponse: function(response) {
                return response.data.categories;
            },
            returnResponse: true
        });
    };
};
var removeSeller = function(sellerId) {
    return {
        type: _store_sellers_constants__WEBPACK_IMPORTED_MODULE_2__/* .REMOVE_SELLER */ .US,
        payload: sellerId
    };
};
var getSellerReviewsSummary = function(seller_id) {
    return function(dispatch) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            dispatch: dispatch,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSellerReviewsSummaryApi */ .hBv,
            apiArgs: [
                seller_id
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(99201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);